import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import useBranches from '@ubeya/shared/hooks/account/useBranches';
import { Button, ButtonHeader, FlexColumn, FlexSpace, SelectHeader } from '@ubeya/shared-web/components';
import { ReactComponent as BaseArrowIcon } from '@ubeya/shared-web/assets/arrow-right-small.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { responsiveShow } from '@ubeya/shared-web/style';
import { getDatesRange } from '@ubeya/shared/constants';

const ArrowIcon = styled(BaseArrowIcon)`
  transform: rotate(90deg);
`;

const Wrapper = styled(FlexColumn)`
  flex: 1;
  padding: 40px 15px 20px;
`;

const Arrow = styled(BaseArrowIcon).attrs(({ $left }) => ({ className: $left ? 'rotate-180' : 'rotate-0' }))``;

const Dates = styled.div`
  ${responsiveShow.tablet}
`;

const DateRangeButtonHeader = styled(ButtonHeader)`
  border: 0px;
  cursor: pointer;
`;

const EmployeeAvailabilityHeader = ({ timeRange, setTimeRange, branch, setBranch, branches }) => {
  const { branchesOptions } = useBranches();

  const { t } = useContext(ConfigContext);

  const filteredBranches = branchesOptions.filter(({ value: branchId }) => (branches || []).includes(branchId));

  const { shortDateFormat } = useContext(ConfigContext);

  const handleNextDate = useCallback(() => {
    setTimeRange({
      start: timeRange.start.add(1, 'week').startOf('week'),
      end: timeRange.end.add(1, 'week').endOf('week')
    });
  }, [setTimeRange, timeRange.end, timeRange.start]);

  const handlePreviousDate = useCallback(() => {
    setTimeRange({
      start: timeRange.start.subtract(1, 'week').startOf('week'),
      end: timeRange.end.subtract(1, 'week').endOf('week')
    });
  }, [setTimeRange, timeRange.end, timeRange.start]);

  const resetDates = useCallback(
    () =>
      setTimeRange({
        ...getDatesRange().thisWeek
      }),
    [setTimeRange]
  );

  return (
    <Wrapper>
      <FlexSpace>
        <FlexSpace>
          <Button secondary narrow type="button" onClick={resetDates}>
            <Trans>{t('thisWeek')}</Trans>
          </Button>
          <DateRangeButtonHeader onClick={handlePreviousDate}>
            <Arrow $left />
          </DateRangeButtonHeader>

          <Dates>
            {timeRange.start.format(shortDateFormat)} - {timeRange.end.format(shortDateFormat)}
          </Dates>

          <DateRangeButtonHeader onClick={handleNextDate}>
            <Arrow />
          </DateRangeButtonHeader>
        </FlexSpace>

        {filteredBranches.length > 1 && (
          <SelectHeader options={filteredBranches} value={branch} onChange={setBranch} icon={ArrowIcon} />
        )}
      </FlexSpace>
    </Wrapper>
  );
};

export default React.memo(EmployeeAvailabilityHeader);
